module.exports = __webpack_public_path__ + "static/media/8_IMAGE_4-SOYBEAN-desktop.9e62a135.jpg";